export default "__VITE_ASSET__0a2b5aaa__"